import React from 'react';
import { useParams } from 'react-router-dom';
import IngresoMuestraForm from '../components/IngresoMuestraForm';

const IngresoMuestraPage = () => {
  const { protocoloMuestra } = useParams();
  const isEditMode = Boolean(protocoloMuestra);

  return (
    <div className="container page-shell">
      <div className="page-header">
        <div>
          <span className="section-kicker">{isEditMode ? 'Edicion' : 'Laboratorio'}</span>
          <h2 className="page-title">{isEditMode ? 'Editar muestra' : 'Ingreso de muestra'}</h2>
          <p className="page-subtitle">
            {isEditMode
              ? 'Actualiza la informacion de la muestra y vuelve al caso cuando termines.'
              : 'Carga una nueva muestra con un formato mas claro y facil de revisar.'}
          </p>
        </div>
        <img src="/logo-inta.png" alt="Logo INTA" className="page-header-logo" />
      </div>
      <IngresoMuestraForm sampleId={protocoloMuestra} />
    </div>
  );
};

export default IngresoMuestraPage;
